import { path } from 'ramda';

import { IGetEstimationRealtorFormRequest } from '../../../repositories/price-estimator/v1/get-estimation-realtor-form';
import { TAnswersState } from '../../../containers/FormContainer/types/internal';
import { getCategory } from './getCategory';
import { EAnswerField } from '../../../types/form';
import { ERoomsCount } from '../../../repositories/price-estimator/entities/estimation/GetEstimationRealtorFormRequestSchema';

/**
 * Функция выполняет роль валидатора, загружать или нет оценку
 * Если есть необходимый набор параметров, то функция их вернет, и оценка загрузится
 * */
export const getParameters = (answersState: TAnswersState): IGetEstimationRealtorFormRequest | null => {
  const houseId = path<number>([EAnswerField.Address, 'value', 'houseId'], answersState);
  const area = path<number>([EAnswerField.Area, 'value'], answersState);
  const reason = path<string>([EAnswerField.DealTypeEx, 'value'], answersState);
  const offerType = path<string>([EAnswerField.OfferType, 'value'], answersState);
  const roomsCount = path<ERoomsCount>([EAnswerField.RoomCount, 'value'], answersState);

  const category = getCategory({ reason, offerType });

  if (!category || !area || !roomsCount || !houseId) {
    return null;
  }

  return {
    area,
    category,
    roomsCount,
    houseId,
  };
};
